import { render, staticRenderFns } from "./DestinationView.vue?vue&type=template&id=9a4704a6&scoped=true&"
import script from "./DestinationView.vue?vue&type=script&lang=js&"
export * from "./DestinationView.vue?vue&type=script&lang=js&"
import style0 from "./DestinationView.vue?vue&type=style&index=0&id=9a4704a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4704a6",
  null
  
)

export default component.exports